<template>
    <DetailLayout
        title="VoIP Shield"
        :loading="detailVoipShieldStore.loading"
        @goBack="backToManagePage"
    >
        <VoipShieldMainSection />

        <ProtectedCampaignsSection />

        <BlockedCarriersSection />
    </DetailLayout>
</template>

<script setup>
import {
    onMounted, onUnmounted, ref, watch,
} from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'

import DetailLayout from '@/layouts/DetailLayout.vue'
import VoipShieldMainSection from '@/views/call-tracking/voip-shield/components/sections/VoipShieldMainSection.vue'
import ProtectedCampaignsSection from '@/views/call-tracking/voip-shield/components/sections/ProtectedCampaignsSection.vue'
import BlockedCarriersSection from '@/views/call-tracking/voip-shield/components/sections/BlockedCarriersSection.vue'

import { useBreadCrumbsStore } from '@/store/breadCrumbsStore'
import { useDetailVoipShieldStore } from '@/store/call-tracking/suppressionList/detailVoipShieldStore'
import { useVoipShieldStore } from '@/store/call-tracking/suppressionList/voipShieldStore'

import { ROUTES } from '@/constants/routes'

const breadCrumbsStore = useBreadCrumbsStore()
const detailVoipShieldStore = useDetailVoipShieldStore()
const voipShieldStore = useVoipShieldStore()

const route = useRoute()
const router = useRouter()

const nextRoute = ref('')

onMounted(() => {
    breadCrumbsStore.setBreadCrumbs([
        { title: 'VoIP Shield', routeName: ROUTES.voipShield },
        { title: 'Setup Shield', view: ROUTES.detailVoipShield },
    ])

    detailVoipShieldStore.getLocalStorageOnPage()
    loadDetailVoipShield()
})

function backToManagePage() {
    router.push({ name: ROUTES.voipShield })
}

async function loadDetailVoipShield() {
    const slug = route.params.slug

    detailVoipShieldStore.setVoipShieldSlug(slug)

    const success = await detailVoipShieldStore.goToLoadDetailVoipShield()

    if (!success) {
        backToManagePage()
    }
}

watch(() => route.params, (params) => {
    if (params?.slug) {
        loadDetailVoipShield()
    }
})

onBeforeRouteLeave((to, from, next) => {
    nextRoute.value = to.name

    next()
})

onUnmounted(() => {
    if (nextRoute.value !== ROUTES.voipShield) {
        voipShieldStore.$reset()
    }

    detailVoipShieldStore.$reset()
    breadCrumbsStore.$reset()
})
</script>
